import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jilu",
  "use": "icon-jilu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jilu\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m0 89.6a358.4 358.4 0 1 0 0 716.8A358.4 358.4 0 0 0 512 153.6zM537.6 320v164.864h127.168v86.848H448V320h89.6z\" p-id=\"6318\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol